/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';
import { RequestBuilder } from '../request-builder';
import { StrictHttpResponse } from '../strict-http-response';

import { CohortTypeEnum } from '../models/cohort-type-enum';
import { ProductDto } from '../models/product-dto';
import { ProductIntensityDto } from '../models/product-intensity-dto';
import { RelatedProductDto } from '../models/related-product-dto';

@Injectable({
  providedIn: 'root',
})
export class ProductService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getProduct
   */
  static readonly GetProductPath = '/products/{id}';

  /**
   * Get Product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProduct$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<ProductDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.GetProductPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductDto>;
      })
    );
  }

  /**
   * Get Product.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProduct(params: {
    id: string;
  }): Observable<ProductDto> {

    return this.getProduct$Response(params).pipe(
      map((r: StrictHttpResponse<ProductDto>) => r.body as ProductDto)
    );
  }

  /**
   * Path part for operation getRelatedProduct
   */
  static readonly GetRelatedProductPath = '/products/{id}/related';

  /**
   * Get Related Product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRelatedProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRelatedProduct$Response(params: {
    id: string;
    cohort: CohortTypeEnum;
    limit: number;
  }): Observable<StrictHttpResponse<Array<RelatedProductDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.GetRelatedProductPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('cohort', params.cohort, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RelatedProductDto>>;
      })
    );
  }

  /**
   * Get Related Product.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRelatedProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRelatedProduct(params: {
    id: string;
    cohort: CohortTypeEnum;
    limit: number;
  }): Observable<Array<RelatedProductDto>> {

    return this.getRelatedProduct$Response(params).pipe(
      map((r: StrictHttpResponse<Array<RelatedProductDto>>) => r.body as Array<RelatedProductDto>)
    );
  }

  /**
   * Path part for operation setProductDefaultIntensity
   */
  static readonly SetProductDefaultIntensityPath = '/products/{id}/intensity';

  /**
   * Set Product Default Intensity.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setProductDefaultIntensity()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setProductDefaultIntensity$Response(params: {
    id: string;
    body: ProductIntensityDto
  }): Observable<StrictHttpResponse<ProductIntensityDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.SetProductDefaultIntensityPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductIntensityDto>;
      })
    );
  }

  /**
   * Set Product Default Intensity.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `setProductDefaultIntensity$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setProductDefaultIntensity(params: {
    id: string;
    body: ProductIntensityDto
  }): Observable<ProductIntensityDto> {

    return this.setProductDefaultIntensity$Response(params).pipe(
      map((r: StrictHttpResponse<ProductIntensityDto>) => r.body as ProductIntensityDto)
    );
  }

}
